<script>
  import SurveyButton from "../../components/SurveyButton.svelte";

  import { clearStorage } from "../../js/local";
  import { post } from "../../js/api";
  import { getToken, setCenter } from "../../js/local";

  import { navigate } from "svelte-routing";

  import { onMount } from "svelte";

  const token = getToken();

  let loading = true;
  let center = "";

  let requestedListTeoria = false;
  let requestedListLab = false;

  onMount(async () => {
    await checkToken();
    await checkCenter();
    loading = false;
  });

  let checkToken = async () => {
    const response = await post("ComprobarToken", {
      token,
    });
    if (response.validToken === "0") {
      clearStorage();
      navigate("/login", { replace: true });
    }
  };

  let checkCenter = async () => {
    const response = await post("ComprobarCentroAsignado", {
      token,
    });
    center = response.codigoCentro;
    setCenter(center);
  };
</script>

{#if loading}
  <div class="loading">
    <img src="/images/loading.gif" alt="Loading Anim" />
  </div>
{:else}
  <div class="screeninicio">
    <img
      src="/images/logo-uex-complete-white.png"
      loading="lazy"
      sizes="(max-width: 479px) 72vw, 399.9999694824219px"
      srcset="
        /images/logo-uex-complete-white-p-500.png   500w,
        /images/logo-uex-complete-white-p-800.png   800w,
        /images/logo-uex-complete-white-p-1080.png 1080w,
        /images/logo-uex-complete-white-p-1600.png 1600w,
        /images/logo-uex-complete-white-p-2000.png 2000w,
        /images/logo-uex-complete-white-p-2600.png 2600w,
        /images/logo-uex-complete-white-p-3200.png 3200w,
        /images/logo-uex-complete-white.png        3994w
      "
      alt=""
      class="logoinicio"
    />
    <div class="titleinicio">
      <span>CUESTIONARIO</span><span
        ><strong class="titleinicio boldtext">
          EVALUACIÓN DEL PROFESORADO</strong
        ></span
      >
    </div>
    {#if requestedListTeoria || requestedListLab}
      <div class="cuestionarios">
        <div class="msgInfo">
          <span><b>ATENCIÓN</b></span>
          <span
            >Va a proceder a ingresar a una sección confidencial y sólamente los
            usuarios autorizados pueden tener acceso a la misma. Haciendo click
            en en botón <i>Continuar</i>, entiende que toda su actividad será
            identificada y monitorizada, siendo cualquier acción ejecutada
            responsabilidad final del usuario actual.</span
          >
          <span
            >De igual manera, se prohíbe la distribución a terceros por medios
            orales, escritos o digitales de la información (completa o parcial)
            presentada en la siguiente sección.</span
          >
          <SurveyButton
            title="CONTINUAR"
            onClick={() => {
              if (requestedListTeoria) {
                navigate("/lista-cuestionarios-teoria");
              } else {
                navigate("/lista-cuestionarios-lab");
              }
            }}
          />
          <SurveyButton
            title="VOLVER"
            onClick={() => {
              requestedListTeoria = false;
              requestedListLab = false;
            }}
          />
        </div>
      </div>
    {:else}
      <div class="cuestionarios">
        {#if center == "" || center === "0"}
          <SurveyButton
            title="INICIAR CUESTIONARIO TEORÍA"
            onClick={() => {
              navigate("/teoria");
            }}
          />
          <SurveyButton
            title="INICIAR CUESTIONARIO LABORATORIO"
            onClick={() => {
              navigate("/lab");
            }}
          />
        {/if}
        {#if center != "" || center === "0"}
          <SurveyButton
            title="LISTAR CUESTIONARIOS TEORÍA"
            onClick={() => {
              requestedListTeoria = true;
            }}
          />
          <SurveyButton
            title="LISTAR CUESTIONARIOS LABORATORIO"
            onClick={() => {
              requestedListLab = true;
            }}
          />
        {/if}
        <div
          class="closeSessionSmall"
          on:click={() => {
            if (window.confirm("¿Desea cerrar la sesión?")) {
              clearStorage();
              navigate("/login", { replace: true });
            }
          }}
        >
          Cerrar Sesión
        </div>
      </div>
    {/if}
  </div>
{/if}

<style>
  div.cuestionarios {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  div.closeSessionSmall {
    font-family: "Open Sans", sans-serif;
    color: #aaa;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    width: 160px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: white;
    border-radius: 20px;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  div.closeSessionSmall:hover {
    opacity: 0.8;
    transition: opacity 0.5s;
  }

  div.loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.loading img {
    width: 40px;
  }

  div.msgInfo {
    display: flex;
    flex-direction: column;
    padding: 10px;
    max-width: 800px;
    text-align: center;
    color: white;
    font-size: 25px;
    line-height: 40px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    letter-spacing: 2px;
    align-items: center;
    margin-bottom: 45px;
  }

  div.msgInfo span b {
    font-weight: 600;
  }

  div.msgInfo span:not(:last-child) {
    margin-bottom: 40px;
  }
</style>
